const topItems = document.querySelectorAll('.header-main-navigation .header__menu_li');
const bottomMenus = document.querySelectorAll('.bottom-menu');

/* Der gleitende Anzeiger. Er folgt dem Zeiger und steht sonst beim offenen
   Punkt. Er faehrt auch ueber den letzten Punkt, den tuerkisen Knopf:
   der ist deckend und liegt darueber, die Pille verschwindet also in ihm,
   statt davor stehen zu bleiben (Vorgabe Fabian 18.09.2026). */
const pill = document.querySelector('.header-main-navigation .hdr-pill');
const navList = document.querySelector('.header-main-navigation ul');
const pillItems = [...topItems];
let pillOpen = null;

function pillTo(item) {
  if (!pill || !navList || !item) return;
  const a = item.querySelector('.header__menu_item') || item;
  const r = a.getBoundingClientRect();
  const b = navList.getBoundingClientRect();
  pill.style.width = Math.round(r.width) + 'px';
  pill.style.transform = 'translateX(' + Math.round(r.left - b.left) + 'px)';
  pill.classList.add('is-on');
}
function pillReset() {
  if (!pill) return;
  if (pillOpen) { pillTo(pillOpen); return; }
  pill.classList.remove('is-on');
}

pillItems.forEach(item => {
  item.addEventListener('mouseenter', () => pillTo(item));
  item.addEventListener('focusin', () => pillTo(item));
});
if (navList) navList.addEventListener('mouseleave', pillReset);
window.addEventListener('resize', () => { if (pill && pill.classList.contains('is-on')) pillReset(); });

/* ---------------------------------------------------------------------
   Die Karte, die waechst.
   Das Panel eines Unterpunkts liegt jetzt IN der Karte: absolut, direkt
   unter der Punktreihe, ohne eigenen Radius und ohne eigenen Schatten
   (siehe header-submenu-styles). Damit die Karte es auch umschliesst,
   statt dass darunter ein zweiter Kasten auftaucht, wird ihre Hoehe
   gesetzt - Reihe allein oder Reihe plus Panel. Geoeffnet wird weiterhin
   von assets/mainMenu.js ueber das open-Attribut der <details>; ein
   MutationObserver haelt die Hoehe daran nach.
   --------------------------------------------------------------------- */
const cardState = new Map();
document.querySelectorAll('.bottom-menu__card').forEach(card => {
  const row = card.querySelector('.header__menu_ul');
  if (!row) return;
  const mark = document.createElement('span');
  mark.className = 'bm-underline';
  mark.setAttribute('aria-hidden', 'true');
  row.appendChild(mark);
  cardState.set(card, { row: row, mark: mark, raf: 0 });
  new MutationObserver(() => paintCard(card)).observe(card, {
    attributes: true, attributeFilter: ['open'], subtree: true
  });
});

function panelOf(card) {
  const open = card.querySelector('details[open]');
  return open ? open.querySelector('.header__mega_menu, .header__sub_menu') : null;
}

/* Die Hoehe eines Panels laesst sich auch geschlossen messen: es ist nur
   visibility:hidden, der Platz bleibt gerechnet. Unsichtbare Karten
   werden uebersprungen, dort misst man sonst Nullen. */
function paintCard(card, instant) {
  const st = cardState.get(card);
  if (!st || !card.offsetParent) return;
  if (st.raf) { cancelAnimationFrame(st.raf); st.raf = 0; }
  const run = () => {
    st.raf = 0;
    const panel = panelOf(card);
    const ziel = st.row.offsetHeight + (panel ? panel.offsetHeight : 0);
    card.classList.toggle('is-grown', !!panel);
    setHeight(card, ziel, instant);
    const open = panel ? card.querySelector('details[open]') : null;
    const sum = open ? open.querySelector('summary') : null;
    if (sum) {
      const a = sum.getBoundingClientRect(), b = st.row.getBoundingClientRect();
      st.mark.style.width = Math.round(a.width) + 'px';
      st.mark.style.transform = 'translateX(' + Math.round(a.left - b.left) + 'px)';
      st.mark.classList.add('is-on');
    } else {
      st.mark.classList.remove('is-on');
    }
  };
  if (instant) run(); else st.raf = requestAnimationFrame(run);
}

function setHeight(card, px, instant) {
  if (!instant) { card.style.height = px + 'px'; return; }
  const t = card.style.transition;
  card.style.transition = 'none';
  card.style.height = px + 'px';
  card.offsetHeight;
  card.style.transition = t;
}

/* Jede Karte faengt zugeklappt an. Ohne das stuende beim naechsten
   Oeffnen noch die Hoehe des zuletzt gezeigten Panels. */
function resetCard(card) {
  const st = cardState.get(card);
  if (!st) return;
  card.querySelectorAll('details[open]').forEach(d => {
    d.removeAttribute('open');
    const sum = d.querySelector('summary');
    if (sum) sum.setAttribute('aria-expanded', 'false');
  });
  if (st.raf) { cancelAnimationFrame(st.raf); st.raf = 0; }
  card.classList.remove('is-grown');
  st.mark.classList.remove('is-on');
  if (card.offsetParent) setHeight(card, st.row.offsetHeight, true);
}

/* Schliessen. Die Karte wird noch im sichtbaren Zustand zugeklappt,
   damit die gespeicherte Hoehe stimmt. */
const closeBottomMenus = () => {
  bottomMenus.forEach(menu => {
    const card = menu.querySelector('.bottom-menu__card');
    if (card) resetCard(card);
    menu.classList.remove('active');
  });
  topItems.forEach(other => {
    other.classList.remove('is-open');
    const a = other.querySelector('a[aria-expanded]');
    if (a) a.setAttribute('aria-expanded', 'false');
  });
  pillOpen = null;
  pillReset();
};

/* Gnadenfrist beim Verlassen: der Weg von der Leiste durch die Bruecke in
   die Karte darf nicht abreissen. Dasselbe Muster wie die 120ms in
   assets/mainMenu.js. */
let closeTimer = null;
function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
function scheduleClose() { cancelClose(); closeTimer = setTimeout(closeBottomMenus, 160); }

let suppressOpen = false;
topItems.forEach(item => {
  const menuHandle = item.dataset.menu;

  const openFor = () => {
    if (suppressOpen) return null;
    cancelClose();
    bottomMenus.forEach(menu => menu.classList.remove('active'));

    const activeMenu = document.querySelector(
      `.bottom-menu[data-menu="${menuHandle}"]`
    );

    topItems.forEach(other => {
      other.classList.remove('is-open');
      const a = other.querySelector('a[aria-expanded]');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
    if (activeMenu) {
      activeMenu.classList.add('active');
      const card = activeMenu.querySelector('.bottom-menu__card');
      if (card) resetCard(card);
      item.classList.add('is-open');
      pillOpen = pillItems.indexOf(item) > -1 ? item : null;
    } else {
      pillOpen = null;
    }
    const topLink = item.querySelector('a');
    if (topLink && activeMenu) topLink.setAttribute('aria-expanded', 'true');
    return activeMenu;
  };
  item.addEventListener('mouseenter', openFor);
  /* Tastatur: Fokus auf einem Punkt oeffnet sein Untermenue, Pfeil runter
     springt hinein (vorher war das Untermenue per Tab nicht erreichbar). */
  item.addEventListener('focusin', openFor);
  const topLink = item.querySelector('a');
  if (topLink && document.querySelector(`.bottom-menu[data-menu="${menuHandle}"]`)) {
    topLink.setAttribute('aria-expanded', 'false');
    topLink.addEventListener('keydown', e => {
      if (e.key !== 'ArrowDown') return;
      const m = openFor();
      /* erstes sichtbares Ziel; Links in zugeklappten details sind nicht fokussierbar */
      const first = m && Array.from(m.querySelectorAll('summary, a[href], button')).find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      if (first) { e.preventDefault(); first.focus(); }
    });
  }
});
/* Fokus verlaesst den Header: Untermenue zu */
if (document.querySelector('.header__area')) {
  document.querySelector('.header__area').addEventListener('focusout', e => {
    if (!e.relatedTarget || !e.relatedTarget.closest('.header__area')) { cancelClose(); closeBottomMenus(); }
  });
}

const headerArea = document.querySelector('.header__area');
if (headerArea) {
  headerArea.addEventListener('mouseenter', cancelClose);
  headerArea.addEventListener('mouseleave', scheduleClose);
}
/* Schliessen per Escape und per Klick ausserhalb des Headers */
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  /* aus dem Untermenue: Fokus zurueck auf den Hauptpunkt */
  const openTop = document.activeElement && document.activeElement.closest('.bottom-menu') ? document.querySelector('.header__menu_li.is-open > a, [data-menu].is-open > a') : null;
  cancelClose(); closeBottomMenus();
  /* Fokus zurueck, ohne dass focusin das Menue gleich wieder oeffnet */
  if (openTop) { suppressOpen = true; openTop.focus(); suppressOpen = false; }
});
document.addEventListener('click', e => { if (!e.target.closest('.header__area')) { cancelClose(); closeBottomMenus(); } });
window.addEventListener('resize', () => {
  document.querySelectorAll('.bottom-menu.active .bottom-menu__card').forEach(c => paintCard(c, true));
});
